import { Utilities } from 'src/app/services/utilities';
import { UtilitiesDate } from 'src/app/services/utilities.date';

import { BaseVariableControl } from './_base-control';
import { AbstractControl, Validators } from '@angular/forms';



export class CalendarControl extends BaseVariableControl {


    formatValue(value: string | Date) {
        if (!value) {
            return null;
        }

        return UtilitiesDate.formatDate(value);
    }

    buildInitialFormControlValue() {
        return this.variable.value != null ? new Date(this.variable.value) : null;
      }

    setValue() {
        const originalValue = this.formControl.value;
        const formattedValue = originalValue && this.formatValue(originalValue);
        this.variable.value = formattedValue;
    }

    createReactiveControl(setValueChangedEvent: boolean = true) {

        this.addFormControl();

        this.setValidators(this.form.controls[this.variable.name]);

        if (setValueChangedEvent) {
            this.setOnChangeEvent(this.form.controls[this.variable.name]);
            this.variable.value = new Date(this.getVariableValue());
        }
    }

    getDisplayValueForGrid(item: any): any {
        const value = item[this.variable.name] || item[this.variable.displayName];
        return value == null ? null : this.formatValue(value);
    }

    getDisplayValue(item: any): any {
        if (item) {
            return item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
        } else {
            return UtilitiesDate.formatDate(this.variable.value, 'MM/dd/yyyy');
        }
    }


    setValidators(formControl: AbstractControl) {

        const validators = this.variable.displayMetadata.templateData.validators?.map(element => {

            let type = <string> element.typeId;
            if (type.includes("RequiredAttribute"))
            {
                return Validators.required;
            }
        });

        formControl.setValidators(Validators.compose(validators));
    }
}
